import getKhattabatAiMessagesStore from "../../../../stores/khattabat-stores/ai-messages";
import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";
import { TSelectionPages } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import IgnoreConversation from "../../matching/shared/IgnoreConversation";

const SideAiActions = withLiteObserverAndTheme<{ pageType: TSelectionPages }>(
  (props) => {
    const { pageType } = props;

    const shouldShowConversations =
      getKhattabatAiMessagesStore().isOpenedAiMesssagesBox.get();

    return !shouldShowConversations ? null : (
      <ET3Div
        width={300}
        height={400}
        alignItems={"center"}
        fDirection={"column"}
        style={{}}
        color={""}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <IgnoreConversation
          pageType={pageType}
          matchIDs={getKhattabatSelectsStore().getMarkedUserIds()}
        />
      </ET3Div>
    );
  }
);

export default SideAiActions;
